import * as React from 'react'

import { Box, Grid } from '@factorialco/deprecated-design-system'
import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { employeeUser } from 'modules/core/store/collections/users'

import useCanSeeApprovalRequest from 'modules/contracts/hooks/useCanSeeApprovalRequest'
import type Contract from 'modules/contracts/lib/Contract'
import { contractVersionEmployee } from 'modules/contracts/lib/contractVersionEmployee'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import employees from 'modules/employees/store/collections/employees'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import Actions from './Actions'
import ApprovalBanner from './ApprovalBanner'
import ContractData from './ContractData'
import Tags from './Tags'

interface Props {
  selectedContractVersion: ContractVersion
  allContractVersionsSorted: ContractVersion[]
  contractVersionRequest?: ContractVersionRequest | undefined
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
  contracts: Contract[]
  onClickEdit: () => void
  onClickFix: () => void
  onClickDelete: () => void
  toggleHistory: () => void
}

const Header = ({
  selectedContractVersion,
  allContractVersionsSorted,
  contractVersionRequest,
  workingConditionVersionApplication,
  contracts,
  onClickEdit,
  onClickFix,
  onClickDelete,
  toggleHistory,
}: Props) => {
  const canPromote = policyAuthorizations.for(
    'contracts.promote',
    contractVersionEmployee(selectedContractVersion, employees)
  )
  const canSeeApprovalRequest = useCanSeeApprovalRequest({
    contractVersionRequest,
    canPromote,
  })

  const employee = contractVersionEmployee(selectedContractVersion, employees)
  if (!employee) return null

  const showApprovalBanner = canSeeApprovalRequest && contractVersionRequest

  return (
    <Box gap="s16">
      {showApprovalBanner && (
        <ApprovalBanner
          contractVersionRequest={contractVersionRequest}
          employeeName={employeeUser(employee).fullName()}
        />
      )}
      <Grid variant="fixed">
        <ContractData
          employee={employee}
          selectedContractVersion={selectedContractVersion}
          allContractVersionsSorted={allContractVersionsSorted}
        />
        <Actions
          employee={employee}
          selectedContractVersion={selectedContractVersion}
          allContractVersionsSorted={allContractVersionsSorted}
          contractVersionRequest={contractVersionRequest}
          contracts={contracts}
          onClickEdit={onClickEdit}
          onClickFix={onClickFix}
          onClickDelete={onClickDelete}
          toggleHistory={toggleHistory}
        />
      </Grid>
      <Tags
        contractVersion={selectedContractVersion}
        employee={employee}
        workingConditionVersionApplication={workingConditionVersionApplication}
      />
    </Box>
  )
}

export default observer(Header)
